import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaDeteccionRiesgosInterface } from "../../../../../interfaces/FechaDeteccionRiesgosInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import SkyClear from "../../../../../img/SkyClear.png";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesTXCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "CONCLUSIÓN DE PREVENCIÓN DE SUSTANCIAS DE ABUSO (TOXICOLÓGICO)";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFechaTX = useMutationData({
    url: `/fecha-toxi/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const mutateSemaforoTX = useMutationData({
    url: `/semaforotx/${evaluadosList_id}`,
    reload: ["evaluado", "semaforotx", `${evaluadosList_id}`],
  });

  const mutateMotivoTX = useMutationData({
    url: `/motivo-conclusion/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "motivo-conclusion"],
  });

  const mutateConclusionTX = useMutationData({
    url: `/conclusionestx/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusionestx"],
  });

  const mutateResultadoTX = useMutationData({
    url: `/resultado-conclusiontx/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "resultado-conclusiontx"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionestx" className="mr-2">
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="fecha_conclusionestx"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_conclusionestx"
                type="date"
                style={isDarkMode ? {
                  backgroundColor: '#374151',
                  color: '#e5e7eb',
                  borderColor: '#4b5563'
                } : {}}
                {...field}
                className="text-center w-full"
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre">NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>

        {/* FOTO */}
        <div className="w-64 h-64 border border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center mt-4 relative z-10">
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-gray-500">Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className="flex items-center gap-2 mt-4 mb-4">
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                onChange={handleRadioChange}
              />
              RECOMENDABLE
            </label>
            <label className="flex items-center gap-2 mt-12 mb-12">
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                onChange={handleRadioChange}
              />
              CON RESERVA
            </label>
            <label className="flex items-center gap-2 mb-12">
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                onChange={handleRadioChange}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad">EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo">SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className="mr-2">
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className="w-32"
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp">CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa">EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            style={isDarkMode ? {
              backgroundColor: '#374151',
              color: '#e5e7eb',
              borderColor: '#4b5563'
            } : {}}
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>
        {/* Motivo de la evaluación */}
        <div className="col-span-1">
          <Label htmlFor="motivo_tx">MOTIVO DE LA EVALUACIÓN:</Label>
          <Controller
            name="motivo_tx"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <select
                {...field}
                id="motivo_tx"
                style={isDarkMode ? {
                  backgroundColor: '#374151',
                  color: '#e5e7eb',
                  borderColor: '#4b5563'
                } : {}}
                className={`border rounded-md p-2 w-60 inline-block mt-2 mb-2 focus:ring-2 ${isDarkMode ? "border-gray-600 bg-gray-700 text-gray-200 focus:ring-blue-400" : "border-gray-300 bg-white text-gray-700 placeholder-gray-500 focus:ring-indigo-400"}`}
              >
                <option value="">Elige</option>
                <option value="CONCLUSIÓN DE PREVENCIÓN DE SUSTANCIAS DE ABUSO (TOXICOLÓGICO)">
                  CONCLUSIÓN DE PREVENCIÓN DE SUSTANCIAS DE ABUSO (TOXICOLÓGICO)
                </option>
                <option value="CONSIGNA ESPECIAL">CONSIGNA ESPECIAL</option>
                <option value="PERMANENCIA">PERMANENCIA</option>
                <option value="ASCENSO">ASCENSO</option>
                <option value="OTRO">OTRO</option>
              </select>
            )}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800 text-white" : "bg-gray-50 text-gray-800"}`}>
      <div className={`text-white p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-700" : "bg-customBlue"}`}>
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIÓN DE VISITA DOMICILIARIA
        </h2>
      </div>

      <div className={`flex flex-col items-center border-dashed border-4 rounded-lg p-8 space-y-4 relative ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-100"}`}>
        {/* Área para agregar conclusión */}
        <div className="w-full mt-4">
          <Controller
            name="conclusion_tx"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="conclusion_tx"
                placeholder="Escribe tus conclusiones aquí..."
                style={isDarkMode ? {
                  backgroundColor: '#374151',
                  color: '#e5e7eb',
                  borderColor: '#4b5563'
                } : {}}
                className={`w-full h-32 p-3 border-2 rounded-md resize-none focus:outline-none focus:ring-2 ${isDarkMode ? "border-gray-600 bg-gray-700 text-gray-200 focus:ring-blue-500" : "border-gray-300 bg-white text-gray-800 focus:ring-blue-500"}`}
                {...field}
                rows={4}
              />
            )}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RESULTADO:</Label>
          <Controller
            name="resultado_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="resultado_conclusion"
                type="text"
                style={isDarkMode ? {
                  backgroundColor: '#374151',
                  color: '#e5e7eb',
                  borderColor: '#4b5563'
                } : {}}
                {...field}
                className="text-center w-full"
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <div className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
          <form
            onSubmit={handleSubmit((data) => {
          console.log(data);

          const formData = {
            ...data,
            recomendacion: selectedRecommendation,
            color_tx:
              selectedRecommendation === "recomendable"
                ? "verde"
                : selectedRecommendation === "con_reserva"
                ? "amarillo"
                : selectedRecommendation === "no_recomendable"
                ? "rojo"
                : "",
          };

          mutateFechaTX.mutate(
            {
              data: { fecha_conclusionestx: data.fecha_conclusionestx },
              tipo: "put",
            },
            {
              onSuccess: () => {
                mutateSemaforoTX.mutate(
                  {
                    data: formData,
                    tipo: "post",
                  },
                  {
                    onSuccess: () => {
                      mutateMotivoTX.mutate(
                        {
                          data: formData,
                          tipo: "post",
                        },
                        {
                          onSuccess: () => {
                            mutateConclusionTX.mutate(
                              {
                                data: formData,
                                tipo: "post",
                              },
                              {
                                onSuccess: () => {
                                  mutateResultadoTX.mutate(
                                    {
                                      data: formData,
                                      tipo: "post",
                                    },
                                    {
                                      onSuccess: () => {
                                        navigate(
                                          `/toxicologica/${evaluadosList_id}`
                                        );
                                      },
                                      onError: (error) => {
                                        console.error(
                                          "Error al guardar Resultado Toxicológico:",
                                          error
                                        );
                                      },
                                    }
                                  );
                                },
                                onError: (error) => {
                                  console.error(
                                    "Error al guardar Conclusión:",
                                    error
                                  );
                                },
                              }
                            );
                          },
                          onError: (error) => {
                            console.error("Error al guardar el Motivo:", error);
                          },
                        }
                      );
                    },
                    onError: (error) => {
                      console.error("Error al guardar Semáforo:", error);
                    },
                  }
                );
              },
              onError: (error) => {
                console.error(
                  "Error al guardar Fecha de Evaluación Toxicológica:",
                  error
                );
              },
            }
          );
        })}
        className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
      >
        {renderHeader()}

        {currentPage === 1 && renderPage1()}
        {currentPage === 2 && renderPage2()}

        <div className={`mt-6 p-4 flex justify-between ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
          {/* Botón Cancelar */}
          {currentPage === 1 && (
            <Button
              color="red"
              className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/toxicologica/${evaluadosList_id}`);
              }}
            >
              Cancelar
            </Button>
          )}

          {/* Botón Siguiente */}
          {currentPage === 1 && (
            <button
              type="button"
              className="bg-blue-500 text-white rounded px-4 py-2"
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Siguiente
            </button>
          )}

          {currentPage > 1 && (
            <Button
              color="blue"
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Anterior
            </Button>
          )}

          {/* Botón Guardar */}
          {currentPage === 2 && (
            <div className="flex space-x-4">
              <button
                type="submit"
                className="bg-green-500 text-white rounded px-4 py-2"
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  </div>
</div>
  );
};
